import { useState } from 'react';
import { Drawer } from '@mantine/core';
import { DataLibraryLayout } from './DataLibraryLayout';
import type { ParticipantsTabConfig } from './participants/useDataLibraryParticipants';
import type { GroupState } from '../common/GroupPanel/GroupPanel';
import type { ActiveFilterRow } from '../common/FilterPanel/FilterPanel';
import classes from './DataLibraryDrawer.module.css';

interface DataLibraryDrawerProps {
  opened: boolean;
  onClose: () => void;
  defaultCohortId?: string;
  defaultTab?: string;
  participantsConfig?: ParticipantsTabConfig;
  /** Increment this counter each time the drawer is opened to force DataLibraryLayout to remount fresh. */
  layoutKey?: number;
  /** MED-661: Initial group-by state for the active tab */
  defaultGroup?: GroupState | null;
  /** MED-661: Initial filters for the active tab */
  defaultFilters?: ActiveFilterRow[];
  /** MED-764: Auto-open participant detail modal for this participant on mount */
  defaultParticipantId?: string;
}

export function DataLibraryDrawer({
  opened,
  onClose,
  defaultCohortId,
  defaultTab,
  participantsConfig,
  layoutKey = 0,
  defaultGroup,
  defaultFilters,
  defaultParticipantId,
}: DataLibraryDrawerProps) {
  // Escape closes the phone cohort panel first, then this Drawer.
  const [cohortPanelOpen, setCohortPanelOpen] = useState(false);
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="right"
      size="100%"
      withCloseButton={false}
      keepMounted={false}
      closeOnEscape={!cohortPanelOpen}
      classNames={{
        body: classes.body,
        content: classes.content,
      }}
    >
      <DataLibraryLayout
        key={layoutKey}
        onClose={onClose}
        defaultCohortId={defaultCohortId}
        defaultTab={defaultTab}
        participantsConfig={participantsConfig}
        defaultGroup={defaultGroup}
        defaultFilters={defaultFilters}
        defaultParticipantId={defaultParticipantId}
        onCohortPanelOverlayChange={setCohortPanelOpen}
      />
    </Drawer>
  );
}
